// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__18ma2","header":"PatientBlock_header__Wmkto","label":"PatientBlock_label__34Pja","option":"PatientBlock_option__3G7Nz"};